.homeRoot {
  position: relative;
  min-height: 100svh;
  overflow: hidden;
  display: grid;
  place-items: center;
  padding: 72px 24px 32px;
  color: #f7edff;
  background:
    radial-gradient(circle at 18% 16%, rgba(101, 244, 217, 0.18), transparent 30%),
    radial-gradient(circle at 82% 18%, rgba(244, 114, 182, 0.18), transparent 28%),
    linear-gradient(145deg, #070413 0%, #130825 38%, #1b0a34 68%, #05030d 100%);
}

.background {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.background::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: radial-gradient(ellipse at center, #000 0 42%, transparent 78%);
}

.opening {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: grid;
  place-items: center;
  overflow: hidden;
  pointer-events: none;
  background:
    radial-gradient(circle at 50% 50%, rgba(40, 18, 78, 0.26), transparent 26%),
    radial-gradient(circle at 50% 42%, rgba(8, 6, 17, 0.2), rgba(1, 1, 8, 0.96) 58%, #000 100%),
    #000;
}

.opening::before,
.opening::after {
  content: "";
  position: absolute;
  inset: -18%;
  opacity: 0.42;
  mix-blend-mode: screen;
  pointer-events: none;
}

.opening::before {
  background:
    radial-gradient(circle at 38% 44%, rgba(124, 84, 255, 0.18), transparent 18%),
    radial-gradient(circle at 62% 46%, rgba(157, 82, 255, 0.15), transparent 20%);
  filter: blur(28px);
}

.opening::after {
  background:
    linear-gradient(90deg, transparent 0 48%, rgba(126, 76, 255, 0.08) 49%, rgba(229, 198, 255, 0.14) 50%, rgba(126, 76, 255, 0.08) 51%, transparent 52%),
    radial-gradient(ellipse at center, transparent 0 24%, rgba(0, 0, 0, 0.52) 62%, rgba(0, 0, 0, 0.88) 100%);
}

.openingAura {
  position: absolute;
  width: min(62vw, 620px);
  height: min(72vh, 720px);
  border-radius: 50%;
  opacity: 0;
  background:
    radial-gradient(ellipse at center, rgba(245, 219, 255, 0.32) 0%, rgba(163, 86, 255, 0.42) 12%, rgba(89, 36, 198, 0.26) 32%, rgba(12, 8, 26, 0) 70%);
  filter: blur(18px);
  transform: scale(0.3);
}

.openingFlare {
  position: absolute;
  width: min(86vw, 880px);
  height: min(44vh, 410px);
  opacity: 0;
  background:
    radial-gradient(ellipse at center, rgba(235, 210, 255, 0.3) 0%, rgba(153, 78, 255, 0.2) 20%, rgba(62, 27, 142, 0.1) 46%, transparent 72%);
  filter: blur(34px);
  transform: scaleX(0.25);
}

.openingLine {
  position: relative;
  z-index: 2;
  width: clamp(22px, 2.4vw, 34px);
  height: min(68vh, 620px);
  border: 1px solid rgba(206, 159, 255, 0.34);
  border-radius: 4px;
  opacity: 0;
  background:
    radial-gradient(ellipse at center, rgba(247, 222, 255, 0.7) 0%, rgba(178, 103, 255, 0.62) 22%, transparent 56%),
    linear-gradient(90deg, rgba(39, 17, 82, 0.92) 0%, rgba(126, 63, 227, 0.9) 24%, rgba(216, 171, 255, 0.84) 50%, rgba(126, 63, 227, 0.9) 76%, rgba(39, 17, 82, 0.92) 100%);
  box-shadow:
    0 0 10px rgba(229, 198, 255, 0.54),
    0 0 32px rgba(171, 88, 255, 0.54),
    0 0 86px rgba(104, 58, 255, 0.34),
    0 0 155px rgba(72, 48, 166, 0.22);
  transform-origin: center;
}

.openingLine::before,
.openingLine::after {
  content: "";
  position: absolute;
  inset: -18% -260%;
  border-radius: 999px;
  pointer-events: none;
}

.openingLine::before {
  background: radial-gradient(ellipse at center, rgba(157, 82, 255, 0.26) 0%, rgba(98, 51, 214, 0.16) 36%, transparent 74%);
  filter: blur(18px);
}

.openingLine::after {
  inset: 0;
  border-radius: 3px;
  background: linear-gradient(180deg, transparent 0%, rgba(255, 240, 255, 0.28) 48%, transparent 100%);
  box-shadow: inset 0 0 10px rgba(255, 235, 255, 0.24);
}

.openingDust {
  position: absolute;
  inset: 0;
  opacity: 0.16;
  background-image:
    radial-gradient(circle, rgba(219, 190, 255, 0.42) 0 1px, transparent 1.5px),
    radial-gradient(circle, rgba(117, 80, 255, 0.26) 0 1px, transparent 1.4px);
  background-position: 0 0, 18px 22px;
  background-size: 74px 74px, 96px 96px;
  mask-image: radial-gradient(ellipse at center, #000 0 34%, transparent 76%);
}

.gridField {
  position: absolute;
  left: 50%;
  top: 50%;
  display: grid;
  grid-template-columns: repeat(8, 42px);
  grid-auto-rows: 42px;
  gap: 12px;
  transform: translate(-50%, -50%) rotateX(58deg) rotateZ(-22deg);
  transform-style: preserve-3d;
}

.gridCell {
  width: 42px;
  height: 42px;
  border: 1px solid rgba(192, 132, 252, 0.24);
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(192, 132, 252, 0.2), rgba(101, 244, 217, 0.08)),
    rgba(8, 5, 22, 0.56);
  box-shadow: 0 0 28px rgba(122, 53, 242, 0.16);
  opacity: 0.12;
}

.orbit {
  position: absolute;
  left: calc(50% - 220px);
  top: calc(50% - 220px);
  width: 440px;
  height: 440px;
  border: 1px solid rgba(101, 244, 217, 0.12);
  border-radius: 999px;
  box-shadow:
    inset 0 0 60px rgba(192, 132, 252, 0.08),
    0 0 120px rgba(56, 189, 248, 0.08);
}

.signalNode {
  position: absolute;
  left: calc(50% - 5px);
  top: calc(50% - 5px);
  width: 10px;
  height: 10px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 999px;
  background: var(--node-color, #65f4d9);
  box-shadow:
    0 0 18px rgba(101, 244, 217, 0.62),
    0 0 38px rgba(192, 132, 252, 0.28);
  transform: rotate(var(--node-angle)) translateX(var(--node-distance));
}

.signalNode:nth-child(3n) {
  --node-color: #f472b6;
  box-shadow:
    0 0 18px rgba(244, 114, 182, 0.56),
    0 0 38px rgba(192, 132, 252, 0.28);
}

.signalNode:nth-child(4n) {
  --node-color: #c084fc;
}

.scanline {
  position: absolute;
  left: 8%;
  right: 8%;
  top: 0;
  height: 180px;
  background:
    linear-gradient(180deg, transparent, rgba(101, 244, 217, 0.16), transparent),
    linear-gradient(90deg, transparent, rgba(247, 237, 255, 0.14), transparent);
  filter: blur(8px);
  opacity: 0;
}

.shell {
  position: relative;
  z-index: 1;
  width: min(980px, 100%);
  padding: 24px;
  border: 1px solid rgba(218, 187, 255, 0.22);
  border-radius: 8px;
  background:
    linear-gradient(145deg, rgba(23, 12, 49, 0.86), rgba(11, 7, 26, 0.9)),
    rgba(8, 5, 20, 0.78);
  box-shadow:
    0 28px 90px rgba(14, 2, 36, 0.58),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  opacity: 0;
}

.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
  text-align: left;
}

.eyebrow {
  margin: 0 0 6px;
  color: #bca6d9;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.title {
  margin: 0;
  color: #fff5ff;
  font-size: clamp(34px, 6vw, 62px);
  line-height: 1;
  letter-spacing: 0;
  text-shadow: 0 0 34px rgba(192, 132, 252, 0.34);
}

.statusPill {
  min-width: 86px;
  padding: 8px 12px;
  border: 1px solid rgba(101, 244, 217, 0.3);
  border-radius: 8px;
  color: #bffdf2;
  background: rgba(101, 244, 217, 0.08);
  text-align: center;
  font-size: 13px;
  font-weight: 800;
}

.routeGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.routeTile {
  --route-accent: #c084fc;
  display: grid;
  grid-template-columns: 54px 1fr;
  align-items: center;
  gap: 12px;
  min-height: 86px;
  padding: 14px;
  border: 1px solid color-mix(in srgb, var(--route-accent), transparent 62%);
  border-radius: 8px;
  color: #f7edff;
  background:
    radial-gradient(circle at 15% 18%, color-mix(in srgb, var(--route-accent), transparent 72%), transparent 36%),
    rgba(13, 8, 31, 0.74);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  text-align: left;
  text-decoration: none;
  opacity: 0;
  transition:
    border-color 160ms ease,
    background-color 160ms ease,
    transform 160ms ease,
    box-shadow 160ms ease;
}

.routeTile:hover,
.routeTile:focus-visible {
  border-color: color-mix(in srgb, var(--route-accent), white 18%);
  background-color: rgba(24, 14, 56, 0.9);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 12px 34px color-mix(in srgb, var(--route-accent), transparent 78%);
  transform: translateY(-2px);
  outline: none;
}

.iconBox {
  display: grid;
  place-items: center;
  width: 54px;
  aspect-ratio: 1;
  border: 1px solid color-mix(in srgb, var(--route-accent), white 16%);
  border-radius: 8px;
  color: #08060d;
  background: linear-gradient(135deg, #fff, var(--route-accent));
  font-size: 15px;
  font-weight: 900;
  line-height: 1;
  box-shadow: 0 0 24px color-mix(in srgb, var(--route-accent), transparent 64%);
}

.routeText {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.routeLabel {
  color: #fff5ff;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.15;
}

.routeDescription {
  color: #bca6d9;
  font-size: 13px;
  line-height: 1.3;
}

@media (max-width: 820px) {
  .routeGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .homeRoot {
    padding: 68px 14px 24px;
  }

  .shell {
    padding: 16px;
  }

  .header {
    align-items: flex-start;
    flex-direction: column;
  }

  .routeTile {
    grid-template-columns: 48px 1fr;
    min-height: 78px;
  }

  .routeGrid {
    grid-template-columns: 1fr;
  }

  .iconBox {
    width: 48px;
  }
}
